import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IStampsOfferReviewRatingHistory } from '@/shared/model/stamps-offer-review-rating-history.model';

const baseApiUrl = 'api/stamps-offer-review-rating-histories';
const baseSearchApiUrl = 'api/_search/stamps-offer-review-rating-histories?query=';

export default class StampsOfferReviewRatingHistoryService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IStampsOfferReviewRatingHistory> {
    return new Promise<IStampsOfferReviewRatingHistory>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IStampsOfferReviewRatingHistory): Promise<IStampsOfferReviewRatingHistory> {
    return new Promise<IStampsOfferReviewRatingHistory>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IStampsOfferReviewRatingHistory): Promise<IStampsOfferReviewRatingHistory> {
    return new Promise<IStampsOfferReviewRatingHistory>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
